<template>
  <aside class="hidden sm:flex border-r relative flex-col justify-around print:hidden bg-blue-900" style="width: 250px">
    <router-link to="/" class="bg-white flex flex-col justify-around" style="height: 122px; width: 250px">
      <Logo id="fabricator_logo" :src="styleStore.fabricator_logo" :customer-name="customerStore.customer_name" />
    </router-link>
    <div class="overflow-y-auto overflow-x-hidden shrink-0 grow h-px">
      <PortalMenuItems :initial-setup />
    </div>
    <div class="mb-4">
      <div class="text-center">
        <TouchBranding />
      </div>
    </div>
  </aside>
</template>

<script>
import { mapStores } from 'pinia'
import { useStyleStore } from '@/pinia/style'
import { useCustomerStore } from '@/pinia/customer'
import PortalMenuItems from '@/components/shared/nav/PortalMenuItems.vue'
import Logo from '@/components/shared/nav/Logo.vue'
import TouchBranding from '@/components/shared/ui/TouchBranding.vue'

export default {
  name: 'SidebarMenu',
  components: {
    PortalMenuItems,
    Logo,
    TouchBranding
  },
  props: {
    initialSetup: Boolean
  },
  data() {
    return {
      show_company_name_as_logo: false
    }
  },
  computed: {
    ...mapStores(useStyleStore, useCustomerStore),
    on_dashboard() {
      return this.$route.name === 'Portal Dashboard'
    },
    on_designer_settings() {
      return this.$route.name === 'Setup'
    }
  },
  methods: {
    vendorLogoMissing() {
      this.show_company_name_as_logo = true
    }
  }
}
</script>
